import { useAdmin } from '../../../contexts/AdminContext'
import React from 'react'
import Heading from '../../../components/Heading'
import Text from '../../../components/Text'
import Button from '../../../components/Button'
import PaymentBox from '../../../compositions/Subscription/PaymentBox/PaymentBox'
import SubscriptionTable from '../../../compositions/Subscription/SubscriptionTable'
import CompanyBox from '../../../compositions/Subscription/CompanyBox'
import { useTranslation } from 'react-i18next'
import { Subscription } from '../../../types/Subscription'
import cx from 'classnames'
import styles from './SubscriptionAdministration.module.css'
import CurrentSubscription from '../../../compositions/Subscription/CurrentSubscription'
import Card from '../../../components/Card'
import { showToast } from '../../../services/ToastService'
import { useNavigate } from 'react-router-dom'

const SubscriptionAdministration: React.FC = () => {
    const { subscriptions, paymentMethods, getSubscription } = useAdmin()
    const { t } = useTranslation(['settings'])
    const navigate = useNavigate()

    return (
        <div className={cx(styles['container'], 'zr-my-6')}>
            <div>
                <Heading level={3}>{t('subscription.welcome')}</Heading>
                <Text>{t('subscription.completedSubs')}</Text>
                <SubscriptionTable subscriptions={subscriptions} />
                {subscriptions.filter(
                    (s: Subscription) => s.host === window.location.host
                ).length === 0 && (
                    <div className={'zr-my-6'}>
                        <Heading level={3}>
                            {t('subscription.bookNewLicense')}
                        </Heading>
                        <div
                            className={
                                'zr-d-flex zr-flex-column zr-justify-between'
                            }
                        >
                            <Text>
                                {paymentMethods.length === 0
                                    ? t('subscription.bookNowMissingPayment')
                                    : t('subscription.bookNow')}
                            </Text>
                            <div className={cx(styles['button-container'])}>
                                <Button
                                    hierarchy={'primary'}
                                    text={t('subscription.bookNewLicense')}
                                    fn={() =>
                                        navigate('/subscription/subscribe')
                                    }
                                    disabled={paymentMethods.length === 0}
                                />
                            </div>
                        </div>
                    </div>
                )}
                <Card
                    classes={'zr-mt-4'}
                    title={t('subscription.currentSubscription')}
                    actions={[
                        {
                            title: t('subscription.syncWithServer'),
                            type: 'secondary',
                            onAction: () => {
                                getSubscription()
                                showToast(t('subscription.syncSuccess'))
                            },
                            classes: 'zr-m-3 zr-w-auto',
                        },
                    ]}
                >
                    <CurrentSubscription />
                </Card>
            </div>
            <div>
                <CompanyBox
                    className={'zr-mb-6'}
                    edit={() => navigate('/subscription/change-company')}
                />
                <PaymentBox />
            </div>
        </div>
    )
}

export default SubscriptionAdministration
